import { useEffect, useRef, useState } from 'react';

function StatEEHeaderSocial({ language, addSocial }) {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const containerRef = useRef(null); // React ignores this container

  useEffect(() => {
    const scriptId = 'stat-ee-js';

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = process.env.REACT_APP_STAT_HEADER_COMPONENT;
      script.type = 'module';
      script.id = scriptId;
      script.async = true;
      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    } else {
      setScriptLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (scriptLoaded && containerRef.current && addSocial) {
      containerRef.current.innerHTML = `
        <stat-ee-header-social 
          data-app="juhtimislauad" 
          data-lang="${language}" 
          data-style="black">
        </stat-ee-header-social>
      `;
    }
  }, [scriptLoaded, language]);

  return <div ref={containerRef}></div>; // React ignores this div
}

export default StatEEHeaderSocial;
